module.exports = __webpack_public_path__ + "static/media/2.3d4c7154.jpg";